import React, { memo } from 'react';
import { TextStyle } from '@ticketmaster/global-design-system';

import styles from './portal.module.scss';
import { TicketModel } from '@/v2/models/ticketModel';

type Props = {
  ticket: TicketModel
};

const TicketPortal = ({ ticket }: Props) => {
  return (
    <div>
      {ticket.exitPortal &&
          <div className={styles.ticketPortal}>
              <TextStyle.Blanc className={styles.ticketPortalText}>
                {ticket.exitPortal}
              </TextStyle.Blanc>
          </div>
      }
    </div>
  );
};

export default (memo(TicketPortal));
